<template>
  <v-app id="forgot">
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container fluid class="text-center">
                  <img src="@/assets/logo.png" height="250" width="auto"/>
                  <!--<div class="display-1 font-weight-bold mt-2 primary--text"></div>-->
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5">¿Olvidaste tu contraseña?</v-card-title>
                    <v-card-text>
                      <p class="pl-1">Ingresa tu usuario y te enviaremos un correo con las instrucciones para reestablecer tu contraseña</p>
                      <v-text-field v-model="username" :disabled="loading" prepend-icon="mdi-account" required
                      label="Usuario" @input="$v.username.$touch()" @blur="$v.username.$touch()">
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :disabled="loading" @click="back()">Volver</v-btn>
                      <v-btn type="submit" text :loading="loading">Enviar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ msgError }}
                </v-snackbar>
                <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
                  {{ msgSuccess }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer padless>
      <v-card class="flex" flat tile color="#ffffff">
        <v-card-text class="py-2 text-center">
          {{ new Date().getFullYear() }} — <strong>Censo MKD</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import services from '@/utils/services'

export default {
  name: 'forgot',
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(50)
    }
  },
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    username: ''
  }),
  computed: {
    usernameErrors() {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.required && errors.push('El campo es obligatorio')
      !this.$v.username.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    }
  },
  methods: {
    clear() {
      this.$v.$reset()
      this.username = ''
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.recovery()
      }
      else {
        this.error = true
        this.msgError = 'El usuario es incorrecto'
      }
    },
    back() {
      this.$router.push('/login')
    },
    recovery() {
      this.loading = true
      setTimeout(() => {
        this.axios.post(services.routes.recovery, { username: this.username })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              this.clear()
              this.success = true
              this.msgSuccess = res.mensaje
            } else {
              this.error = true
              this.msgError = res.mensaje
            }
          })
          .catch(error => {
            console.log(error)
            this.error = true
            this.msgError = 'El servicio no se encuentra disponible en estos momentos'
          })
          .finally(() => {
            this.loading = false
          })
      }, 300)
    }
  }
}
</script>

